<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title>
      <v-flex xs12 v-if="messages">
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs6 >
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="benefit" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
      <td v-for="column in selectedColumns" :key="column">
        {{props.item[column]}}
      </td>
      <td class="text-xs-right">
        <table-action :rowData="props" review @review="doCvrUomReview" remove @remove="doPromptRemove(props.item)"></table-action>
      </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNewCvrUomForm">New Unit Of Measure<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="reviewCvrUom" max-width="900px" persistent>
      <v-card>
        <v-card-title v-if='newCvrUom'>
          <span class="headline">New Unit Of Measure</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">Unit Of Measure</span>
        </v-card-title>
        <form data-vv-scope="cvrUomForm">
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap v-if="newCvrUom">
                <v-flex xs6>
                  <v-autocomplete data-vv-scope="cvrUomForm" :items="uomList" v-model="cvrUomForm.uom" :label="labels.uom" item-text="label" item-value="value" :error-messages="errors.collect('cvrUomForm.uom')" data-vv-name="uom" :data-vv-as="labels.uom" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="cvrUomForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="cvrUomForm.uomAmt" :label="labels.uomAmt" :error-messages="errors.collect('cvrUomForm.uomAmt')" data-vv-name="uomAmt" :data-vv-as="labels.uomAmt" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="cvrUomForm" v-model="cvrUomForm.seqNo" :label="labels.seqNo" :error-messages="errors.collect('cvrUomForm.seqNo')" data-vv-name="seqNo" :data-vv-as="labels.seqNo" v-validate="'numeric|max:10'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope="cvrUomForm" :items="benefitList" v-model="cvrUomForm.defBenefit" :label="labels.defBenefit" item-text="label" item-value="value" :error-messages="errors.collect('cvrUomForm.defBenefit')" data-vv-name="defBenefit" :data-vv-as="labels.defBenefit" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.addable" v-model="cvrUomForm.addable"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.defUOM" v-model="cvrUomForm.defUOM"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.permitAgent" v-model="cvrUomForm.permitAgent"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.uom}}</v-subheader>
                  <div class="title">{{cvrUomForm.uom}} - {{cvrUomForm.uomDesc}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="cvrUomForm" v-model="cvrUomForm.uomAmt" v-num-mask="{negative: true, intScale: 18, decScale: 2}" :label="labels.uomAmt" :error-messages="errors.collect('cvrUomForm.uomAmt')" data-vv-name="uomAmt" :data-vv-as="labels.uomAmt" v-validate="'required|max:26'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="cvrUomForm" v-model="cvrUomForm.seqNo" :label="labels.seqNo" :error-messages="errors.collect('cvrUomForm.seqNo')" data-vv-name="seqNo" :data-vv-as="labels.seqNo" v-validate="'numeric|max:10'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope="cvrUomForm" :items="benefitList" v-model="cvrUomForm.defBenefit" :label="labels.defBenefit" item-text="label" item-value="value" :error-messages="errors.collect('cvrUomForm.defBenefit')" data-vv-name="defBenefit" :data-vv-as="labels.defBenefit"></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.addable" v-model="cvrUomForm.addable"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.defUOM" v-model="cvrUomForm.defUOM"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope="cvrUomForm" :label="labels.permitAgent" v-model="cvrUomForm.permitAgent"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseCvrUomForm">Cancel</v-btn>
            <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSaveCvrUomForm">
              {{newCvrUom ? 'Save Unit of Measure' : 'Update Unit of Measure'}}
              <v-icon right>{{newCvrUom ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Coverage Unit Of Messure?
      <div class="title">{{deleteUom}}</div>
    </confirm>
  </v-card>
</template>

<script>
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      columns: [
        { text: 'Unit Of Measure', value: 'uomDesc' },
        { text: 'Unit Of Measure Amount', value: 'uomAmt' },
        { text: 'Addable', value: 'addable' },
        { text: 'Default Benefit', value: 'defBenefitDesc' },
        { text: 'Default Unit Of Measure', value: 'defUOM' },
        { text: 'Permitted Agent', value: 'permitAgent' },
        { text: 'Sequence', value: 'seqNo' }
      ],
      selectedColumns: [ 'seqNo', 'uomDesc', 'uomAmt', 'permitAgent' ],
      pagination: {
        sortBy: 'seqNo'
      },
      cvrUomForm: {
        uom: null,
        uomAmt: null,
        addable: false,
        defBenefit: null,
        defUOM: false,
        permitAgent: false,
        seqNo: null
      },
      labels: {
        uom: 'Unit Of Measure*',
        uomAmt: 'Unit Of Measure Amount*',
        addable: 'Addable',
        defBenefit: 'Default Benefit',
        defUOM: 'Default Unit Of Measure',
        permitAgent: 'Permitted Agent',
        seqNo: 'Sequence'
      },
      newCvrUom: false,
      reviewCvrUom: false,
      submitting: false,
      loading: false,
      uomList: [],
      benefitList: [],
      deleteUom: '',
      promptRemove: false
    }
  },
  watch: {
    'ids.cover': function(value) {
      this.fetchData(value)
    }
  },
  computed: {
    busClsCoverMenu() {
      return this.$store.state.parameters.busCls.cover.menu
    }
  },
  methods: {
    async fetchData(cover) {
      this.loading = true
      const apiURI = this.busClsCoverMenu.busClsCoverUoms
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            cover: cover
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((busClsCvrUom) => {
              const convertList = {
                defBenefit: busClsCvrUom.defBenefit,
                defBenefitDesc: this.checkNullVal(busClsCvrUom.defBenefit + ' - ' + busClsCvrUom.defBenefitDesc),
                defUOM: this.formatBoolean(busClsCvrUom.defUOM),
                permitAgent: this.formatBoolean(busClsCvrUom.permitAgent),
                addable: this.formatBoolean(busClsCvrUom.addable),
                seqNo: busClsCvrUom.seqNo,
                uomDesc: busClsCvrUom.uom + ' - ' + busClsCvrUom.uomDesc,
                uom: busClsCvrUom.uom,
                uomAmt: formatDisplayNumber(busClsCvrUom.uomAmt)
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCvrUomReview(item) {
      const apiURI = this.busClsCoverMenu.busClsCoverUomGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            cover: this.ids.cover,
            uom: item.item.uom
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.cvrUomForm.uom = data.busClsCvrUom.uom
            this.cvrUomForm.uomDesc = data.busClsCvrUom.uomDesc
            this.cvrUomForm.uomAmt = formatDisplayNumber(data.busClsCvrUom.uomAmt)
            this.cvrUomForm.addable = data.busClsCvrUom.addable
            this.cvrUomForm.defBenefit = data.busClsCvrUom.defBenefit
            this.cvrUomForm.defUOM = data.busClsCvrUom.defUOM
            this.cvrUomForm.permitAgent = data.busClsCvrUom.permitAgent
            this.cvrUomForm.seqNo = data.busClsCvrUom.seqNo
            this.reviewCvrUom = true
            this.newCvrUom = false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClearCvrUomForm() {
      this.cvrUomForm.uom = null
      this.cvrUomForm.uomDesc = null
      this.cvrUomForm.uomAmt = null
      this.cvrUomForm.addable = false
      this.cvrUomForm.defBenefit = null
      this.cvrUomForm.defUOM = false
      this.cvrUomForm.permitAgent = false
      this.cvrUomForm.seqNo = null
    },
    doNewCvrUomForm() {
      this.doClearCvrUomForm()
      this.newCvrUom = true
      this.reviewCvrUom = true
    },
    doCloseCvrUomForm() {
      this.resetValidator()
      this.resetMessages()
      this.newCvrUom = false
      this.reviewCvrUom = false
    },
    doSaveCvrUomForm() {
      this.resetMessages()
      this.$validator.validateAll('cvrUomForm').then(result => {
        if (result) {
          if (this.newCvrUom) {
            this.doCreateCvrUomForm()
          } else {
            this.doUpdateCvrUomForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateCvrUomForm() {
      try {
        const apiURI = this.busClsCoverMenu.busClsCoverUomCreate
        if (apiURI) {
          const formatForm = {
            busCls: this.ids.busCls,
            cvrType: this.ids.cover,
            uom: this.cvrUomForm.uom,
            uomAmt: removeFormatNumber(this.cvrUomForm.uomAmt),
            addable: this.cvrUomForm.addable,
            defBenefit: this.cvrUomForm.defBenefit,
            defUom: this.cvrUomForm.defUOM,
            permitAgent: this.cvrUomForm.permitAgent,
            seqNo: this.cvrUomForm.seqNo
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseCvrUomForm()
            this.fetchData(this.ids.cover)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdateCvrUomForm() {
      try {
        const apiURI = this.busClsCoverMenu.busClsCoverUomUpdate
        if (apiURI) {
          const formatForm = {
            busCls: this.ids.busCls,
            cvrType: this.ids.cover,
            uom: this.cvrUomForm.uom,
            uomAmt: removeFormatNumber(this.cvrUomForm.uomAmt),
            addable: this.cvrUomForm.addable,
            defBenefit: this.cvrUomForm.defBenefit,
            defUom: this.cvrUomForm.defUOM,
            permitAgent: this.cvrUomForm.permitAgent,
            seqNo: this.cvrUomForm.seqNo
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseCvrUomForm()
            this.fetchData(this.ids.cover)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUomListInit() {
      const apiURI = this.busClsCoverMenu.uomList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          if (this.uomList.length > 0) {
            this.uomList = []
          }
          data.map((uom) => {
            const convertList = {
              label: uom.uom + ' - ' + uom.uomShortDesc,
              value: uom.uom
            }
            this.uomList.push(convertList)
          })
        } else {
          this.uomList = []
        }
      }
    },
    async doBenefitInit() {
      const apiURI = this.busClsCoverMenu.benefitList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data

        if (data) {
          if (this.benefitList.length > 0) {
            this.benefitList = []
          }
          data.map((benefit) => {
            const convertList = {
              label: benefit.benefit + ' - ' + benefit.benShortDesc,
              value: benefit.benefit
            }
            this.benefitList.push(convertList)
          })
        } else {
          this.benefitList = []
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedUom = data
        this.deleteUom = data.defBenefit + ' - ' + data.uom
      }
    },
    async doRemove() {
      const apiURI = this.busClsCoverMenu.busClsCoverUomDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.ids.busCls,
          cvrType: this.ids.cover,
          uom: this.selectedUom.uom,
          uomAmt: removeFormatNumber(this.selectedUom.uomAmt),
          addable: this.removeFormatBoolean(this.selectedUom.addable),
          defBenefit: this.selectedUom.defBenefit,
          defUom: this.removeFormatBoolean(this.selectedUom.defUOM),
          permitAgent: this.removeFormatBoolean(this.selectedUom.permitAgent),
          seqNo: this.selectedUom.seqNo
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.cover)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Coverage Unit Of Messure')
      }
    },
    removeFormatBoolean(boolean) {
      if (boolean === 'Yes') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    Promise.all([this.fetchData(this.ids.cover), this.doUomListInit(), this.doBenefitInit()])
  },
  props: {
    ids: Object
  },
  mixins: [
    listMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
